<template>
  <div>
    <b-modal
      :id="dialogId"
      :title="dialogTitle"
      :centered="dialogVerticalCenter"
      @ok="e => $emit('ok', e)"
      @hidden="e => $emit('hidden', e)"
      @cancel="e => $emit('cancel', e)"
    >
      {{ dialogMessage }}
      <template v-slot:modal-footer="{ ok, cancel }">
        <slot name="modal-footer">
          <b-button
            size="sm"
            variant="outline-secondary"
            @click="cancel()"
          >
            Nej
          </b-button>
          <b-button
            size="sm"
            variant="primary"
            @click="ok()"
          >
            Ja
          </b-button>
        </slot>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
    name: "ConfirmDialog",
    props: {
        dialogId: String,
        dialogTitle: {
            type: String,
            default: "Är du säker?",
        },
        dialogMessage: {
            type: String,
            default: "Du har gjort förändringar i dialogen. Är du säker på att du vill stänga den utan att spara?",
        },
        dialogVerticalCenter: {
            type: Boolean,
            default: false,
        },
    }
}
</script>

<style scoped></style>
